<template>
  <l-layout :layout="['xs12']" bottom-space>
    <v-layout justify-center>
      <v-flex xs12>
        <v-card class="pa-3">
          <v-form ref="commonForm" v-if="ownerType==='common'">
            <template v-for="(c, key, i) in commonConfigs">
              <v-layout row :key="key" align-center>
                <v-flex class="px-2" :key="'label' + key" xs8>
                    <span class="subheading grey--text">{{c.label}}</span>
                </v-flex>
                <v-flex :key="'input' + key" xs2 offset-xs2>
                  <v-text-field
                    v-model="c.value"
                    :disabled="!enableReservation"
                    :rules="$rules.positiveInteger"
                    :suffix="c.suffix"
                  ></v-text-field>
                </v-flex>
              </v-layout>
            </template>
          </v-form>
          <v-form ref="objectForm" v-if="ownerType==='object'">
            <v-layout>
              <v-flex  xs4 class="pl-4">
                <v-autocomplete
                  :disabled="(status!=='new')"
                  :items="searchSelects"
                  v-model="owner"
                  v-on:keyup="getUsers"
                  label="个人名称"
                  clearable
                  hide-details
                  hide-selected
                  item-text="name"
                  item-value="id"
                  :init-data="false"
                  :rule="[$rules.requiredS('必填')]"
                >
                  <template slot="no-data">
                    <v-alert :value="true" color="error">
                      暂无该用户信息
                    </v-alert>
                  </template>
                  <template slot="item" slot-scope="props">
                    <v-list-tile-content>
                      <v-list-tile-title>
                        <v-flex row align-center justify-between>
                          <span>{{props.item.name}}</span>
                        </v-flex>
                      </v-list-tile-title>
                    </v-list-tile-content>
                    <v-list-tile-action>
                      <span class="grey--text caption text-xs-right">{{props.item.loginId}}</span>
                    </v-list-tile-action>
                  </template>
                </v-autocomplete>
              </v-flex>
            </v-layout>
            <v-layout row  align-center pl-3>
              <v-flex class="px-2"  xs2>
                <span class="subheading grey--text">最大允许添加车辆数</span>
              </v-flex>
              <v-flex xs2 >
                <v-text-field
                  v-model="commonConfigs.personMaxAllowed.value"
                  :disabled="!enableReservation"
                  :rules="$rules.positiveInteger"
                  :suffix="commonConfigs.personMaxAllowed.suffix"
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-form>
          <v-form ref="groupForm" v-if="ownerType==='group'">
            <v-layout v-if="ownerType==='group'" class="mb-3">
              <v-flex xs4 class="pl-4">
                <v-autocomplete
                  :disabled="(status!=='new')"
                  :items="searchSelects"
                  v-model="owner"
                  v-on:keyup="getGroups"
                  label="分组名称"
                  clearable
                  hide-details
                  hide-selected
                  item-text="name"
                  item-value="id"
                  :rule="[$rules.requiredS('必填')]"
                >
                  <template slot="no-data">
                    <v-alert :value="true" color="error">
                      暂无该用户组信息
                    </v-alert>
                  </template>
                  <template slot="item" slot-scope="props">
                    <v-list-tile-content>
                      <v-list-tile-title>
                        <v-flex row align-center justify-between>
                          <span>{{props.item.name}}</span>
                        </v-flex>
                      </v-list-tile-title>
                    </v-list-tile-content>
                    <v-list-tile-action>
                      <span class="grey--text caption text-xs-right">{{props.item.code}}</span>
                    </v-list-tile-action>
                  </template>
                </v-autocomplete>
              </v-flex>
            </v-layout>
            <v-layout row  align-center pl-3>
              <v-flex class="px-2"  xs2>
                <span class="subheading grey--text">最大允许添加车辆数</span>
              </v-flex>
              <v-flex xs2 >
                <v-text-field
                  v-model="commonConfigs.groupMaxAllowed.value"
                  :disabled="!enableReservation"
                  :rules="$rules.positiveInteger"
                  :suffix="commonConfigs.groupMaxAllowed.suffix"
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-form>
          <v-layout>
            <v-spacer></v-spacer>
              <v-btn  flat color="primary" class="mx-0" v-if="!enableReservation" @click="changeStatus">修改</v-btn>
              <v-btn  flat color="grey" class="mx-0" v-if="enableReservation" @click="enableReservation=false">取消</v-btn>
              <v-btn
                key="submit"
                v-if="enableReservation"
                @click="(ownerType==='common')?submitCommonConfig():putConfig()"
                flat color="primary"
                class="mx-0"
              >确认
              </v-btn>
          </v-layout>
          <v-form>
          </v-form>
        </v-card>
      </v-flex>
    </v-layout>
  </l-layout>
</template>
<script>
import LDataTable from '../../ladmin/components/LDataTable/LDataTable'
import LPlatePicker from '../../components/LPlatePicker'
export default{
  name: 'commonConfig',
  components: {LDataTable, LPlatePicker},
  props: {
    statusProp: {
      type: String,
      default: 'readonly'
    },
    ownerTypeProp: {
      type: String,
      default: 'common'
    },
    ownerIdProp: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      status: 'new',
      ownerType: '',
      enableEditExtra: false,
      enableReservation: true,
      readonly: true,
      loading: false,
      searchSelects: [],
      ownerId: '',
      owner: '',
      configId: '',
      commonConfigs: {
        personMaxAllowed: {label: '个人最大可登记车辆数', value: 0, type: 'input', suffix: '辆'},
        groupMaxAllowed: {label: '分组最大可登记车辆数', value: 0, type: 'input', suffix: '辆'},
      },
      extraInfo: {
        driver: '',
        driverSelect: [],
        admin: [],
        adminSelect: [],
        vehicle: '',
        vehicleSelect: [],
        groupUserSelect: [],
        driverHeader: [
          {text: '驾驶员姓名', value: 'name', align: 'left', sortable: false},
          {text: '驾驶员ID', value: 'loginId', align: 'left'},
          {text: '', value: ''}
        ],
        adminHeader: [
          {text: '管理员姓名', value: 'name', align: 'left', sortable: false},
          {text: '管理员ID', value: 'loginId', align: 'left'},
          {text: '', value: ''}
        ],
        vehicleHeader: [
          {text: '车牌号', value: 'id', align: 'left'},
          {text: '', value: '', sortable: false}
        ],
        showDrivers: false,
        showAdmins: false,
        showVehicles: false
      }
    }
  },
  created () {
    this.initViewProp()
    if (this.ownerType === 'common') {
      this.enableReservation = false
      this.getCommonConfigInfo()
    }
    else if (this.status === 'new') {
      this.enableReservation = true
    }
    else if (this.status === 'readonly') {
      this.getConfigInfo()
      this.enableReservation = false
    }
    console.log(this.status)
  },
  methods: {
    initViewProp () {
      if (this.$route.query.ownerType === undefined) {
        this.ownerType = this.ownerTypeProp
      }
      else {
        this.ownerType = this.$route.query.ownerType
      }
      if (this.$route.query.status === undefined) {
        this.status = this.statusProp
      }
      else {
        this.status = this.$route.query.status
      }
      if (this.$route.query.ownerId === undefined) {
        this.ownerId = this.ownerIdProp
      }
      else {
        this.ownerId = this.$route.query.ownerId
      }
      if(this.$route.query.userId!==undefined){
        this.getConfigUser(this.$route.query.userId)
      }
    },
    async getConfigInfo () {
      let searchParam = {
        'searchParam': {
          'ownerType': {
            'order': 'ASC',
            'operators': [
              {
                'keyword': this.ownerType,
                'operator': 'EQ',
                'matchType': 'NONE'
              }
            ],
            'index': 1
          },
          'ownerId': {
            'order': 'ASC',
            'operators': [
              {
                'keyword': this.ownerId,
                'operator': 'EQ',
                'matchType': 'NONE'
              }
            ],
            'index': 1
          }
        }
      }
      let pagination = {
        page: 1,
        rowsPerPage: 10
      }
      let res = await this.$store.dispatch('vehicleRegister/getConfigList', {searchParam: searchParam, pagination: pagination})
      if (res.data.status === 1) {
        this.dealConfigInfo(res.data.data.content[0])
        /* if (this.ownerType === 'group') {
          this.getExtraConfig()
        } */
      }
    },
    dealConfigInfo (data) {
      console.log(data)
      this.owner = {
        name: (this.ownerType === 'group') ? data.group.name : data.user.name,
        id: this.ownerId
      }
      this.searchSelects.push(this.owner)
      if (this.ownerType === 'group') {
        this.commonConfigs.groupMaxAllowed.value = data.config.maxAllowed
        this.enableEditExtra = true
      }
      else {
        this.commonConfigs.personMaxAllowed.value = data.config.maxAllowed
      }
      this.configId = data.config.id
    },
    getExtraConfig () {
      this.getDrivers()
      this.getAdmins()
      this.getVehicles()
    },
    async getConfigUser (id) {
      let pagination = {page: 0, rowsPerPage: 10}
      let param = {
        'searchParam': {
          'id': {
            'index': '1',
            'order': 'DESC',
            'operators': [
              {
                'keyword': id,
                'operator': 'LIKE',
                'matchType': 'BOTH'
              }
            ]
          }
        }
      }
      let res = await this.$store.dispatch('reservationConfig/getUsers', {param: param, pagination: pagination})
      if (res.data.status === 1) {
        this.owner = res.data.data.content[0]
        this.searchSelects = []
        this.searchSelects.push(res.data.data.content[0])
      }
      else {
        this.$L.alert('error', {message: res.data.msg})
      }
    },
    async getUsers (data) {
      let search = (data === undefined) ? '' : data.target.value
      let pagination = {page: 0, rowsPerPage: 100}
      let param = {
        'searchParam': {
          'name': {
            'index': '1',
            'order': 'DESC',
            'operators': [
              {
                'keyword': search,
                'operator': 'LIKE',
                'matchType': 'BOTH'
              }
            ]
          }
        }
      }
      let res = await this.$store.dispatch('reservationConfig/getUsers', {param: param, pagination: pagination})
      if (res.data.status === 1) {
        this.searchSelects = res.data.data.content
      }
      else {
        this.searchSelects = []
      }
    },
    async getGroups (data) {
      let search = (data === undefined) ? '' : data.target.value
      let pagination = {page: 0, rowsPerPage: 10}
      let param = {
        'searchParam': {
          'name': {
            'index': '1',
            'order': 'DESC',
            'operators': [
              {
                'keyword': search,
                'operator': 'LIKE',
                'matchType': 'BOTH'
              }
            ]
          }
        }
      }
      let res = await this.$store.dispatch('reservationConfig/getGroups', {param: param, pagination: pagination})
      if (res.data.status === 1) {
        this.searchSelects = res.data.data.content
      }
      else {
        this.searchSelects = []
      }
    },
    async getGroupUsers (data) {
      let search = (data === undefined) ? '' : data.target.value
      let pagination = {page: 0, rowsPerPage: 10}
      let param = {
        'searchParam': {
          'name': {
            'index': '1',
            'order': 'DESC',
            'operators': [
              {
                'keyword': search,
                'operator': 'LIKE',
                'matchType': 'BOTH'
              }
            ]
          }
        }
      }
      let res = await this.$store.dispatch('reservationConfig/getGroupUsers', {param: param, pagination: pagination, id: this.ownerId})
      if (res.data.status === 1) {
        // alert(1)
        // console.log(res)
        this.extraInfo.groupUserSelect = res.data.data.content
      }
      else {
        this.extraInfo.groupUserSelect = []
      }
    },
    async submitCommonConfig () {
      let param = {
        'personMaxAllowed': this.commonConfigs.personMaxAllowed.value,
        'groupMaxAllowed': this.commonConfigs.groupMaxAllowed.value
      }
      this.loading = true
      let res = await this.$store.dispatch('vehicleRegister/submitCommonConfig', param)
      this.loading = false
      if (res.data.status === 1) {
        this.$L.alert('success', {message: '修改成功'})
        this.enableReservation = false
      }
      else {
        this.$L.alert('error', {message: '修改失败，原因：' + res.data.msg})
      }
    },
    async getCommonConfigInfo () {
      let res = await this.$store.dispatch('vehicleRegister/getCommonConfig')
      if (res.data.status === 1) {
        this.commonConfigs.personMaxAllowed.value = res.data.data.personMaxAllowed
        this.commonConfigs.groupMaxAllowed.value = res.data.data.groupMaxAllowed
      }
      else {
        this.$L.alert('error', {message: '查询全局配置失败，原因：' + res.data.msg})
      }
    },
    async putConfig () {
      this.ownerId = (this.owner instanceof Object) ? this.owner.id : this.owner
      let param = {
        'maxAllowed': (this.ownerType === 'group') ? this.commonConfigs.groupMaxAllowed.value : this.commonConfigs.personMaxAllowed.value,
        'ownerId': this.ownerId,
        'ownerType': this.ownerType,
        'id': (this.status === 'new') ? '' : this.configId
      }
      this.loading = true
      let res = await this.$store.dispatch('vehicleRegister/putConfig', param)
      this.loading = false
      if (res.data.status === 1) {
        this.$L.alert('success', {message: (this.status === 'new') ? '添加成功' : '修改成功'})
        this.enableReservation = false
        this.enableEditExtra = true
      }
      else {
        this.$L.alert('error', {message: '提交失败，原因：' + res.data.msg})
      }
    },
    addDriver () {
      if (this.extraInfo.driver === '') {
        this.$L.alert('error', {message: '添加公车驾驶员不能为空'})
      }
      else {
        let ids = []
        // console.log(this.extraInfo.driverSelect)
        for (let n in this.extraInfo.driverSelect) {
          ids.push(this.extraInfo.driverSelect[n].id)
        }
        ids.push(this.extraInfo.driver)
        this.extraInfo.driver = ''
        this.updateDrivers(ids)
      }
    },
    async updateDrivers (ids) {
      let res = await this.$store.dispatch('vehicleRegister/addExtroConfig', {id: this.ownerId, type: 'driver', ids: ids})
      if (res.data.status === 1) {
        this.$L.alert('success', {message: '更新成功'})
        this.getDrivers()
      }
    },
    async getDrivers () {
      let res1 = await this.$store.dispatch('vehicleRegister/getExtroConfig', {id: this.ownerId, type: 'driver'})
      console.log(res1)
      if (res1.data.status === 1) {
        this.extraInfo.driverSelect = res1.data.data
      }
      else {
        this.$L.alert('error', {message: '获取驾驶员列表失败，原因：' + res1.data.msg})
      }
    },
    deleteDriver (item) {
      let index
      for (let i = 0; i < this.extraInfo.driverSelect.length; i++) {
        if (this.extraInfo.driverSelect[i].id === item.id) {
          index = i
          break
        }
      }
      this.extraInfo.driverSelect.splice(index, 1)
      let ids = []
      for (let n in this.extraInfo.driverSelect) {
        ids.push(n.id)
      }
      this.updateDrivers(ids)
    },
    addAdmin () {
      if (this.extraInfo.admin === '') {
        this.$L.alert('error', {message: '添加管理员不能为空'})
        return
      }
      let ids = []
      for (let n in this.extraInfo.adminSelect) {
        ids.push(this.extraInfo.adminSelect[n].id)
      }
      ids.push(this.extraInfo.admin)
      this.extraInfo.admin = ''
      this.updateAdmin(ids)
    },
    async updateAdmin (ids) {
      let res = await this.$store.dispatch('vehicleRegister/addExtroConfig', {id: this.ownerId, type: 'admin', ids: ids})
      if (res.data.status === 1) {
        this.$L.alert('success', {message: '更新成功'})
        this.getAdmins()
      }
    },
    async getAdmins () {
      let res1 = await this.$store.dispatch('vehicleRegister/getExtroConfig', {id: this.ownerId, type: 'admin'})
      if (res1.data.status === 1) {
        this.extraInfo.adminSelect = res1.data.data
      }
      else {
        this.$L.alert('error', {message: '获取驾驶员列表失败，原因：' + res1.data.msg})
      }
    },
    deleteAdmin (item) {
      let index
      for (let i = 0; i < this.extraInfo.driverSelect.length; i++) {
        if (this.extraInfo.adminSelect[i].id === item.id) {
          index = i
          break
        }
      }
      this.extraInfo.adminSelect.splice(index, 1)
      let ids = []
      for (let n in this.extraInfo.adminSelect) {
        ids.push(n.id)
      }
      this.updateAdmin(ids)
    },
    addVehicle () {
      if (this.extraInfo.vehicle === '') {
        this.$L.alert('error', {message: '添加公车不能为空'})
        return
      }
      let ids = []
      for (let n in this.extraInfo.vehicleSelect) {
        ids.push(this.extraInfo.vehicleSelect[n].id)
      }
      ids.push(this.extraInfo.vehicle)
      this.extraInfo.vehicle = ''
      this.updateVehicle(ids)
    },
    async updateVehicle (ids) {
      let res = await this.$store.dispatch('vehicleRegister/addExtroConfig', {id: this.ownerId, type: 'vehicle', ids: ids})
      if (res.data.status === 1) {
        this.$L.alert('success', {message: '更新成功'})
        this.getVehicles()
      }
    },
    async getVehicles () {
      let res1 = await this.$store.dispatch('vehicleRegister/getExtroConfig', {id: this.ownerId, type: 'vehicle'})
      console.log(res1)
      if (res1.data.status === 1) {
        this.extraInfo.vehicleSelect = []
        for (var i = 0; i < res1.data.data.length; i++) {
          var obj = {
            id: res1.data.data[i]
          }
          this.extraInfo.vehicleSelect.push(obj)
        }
      }
      else {
        this.$L.alert('error', {message: '获取驾驶员列表失败，原因：' + res1.data.msg})
      }
    },
    deleteVehicle (item) {
      let index
      for (let i = 0; i < this.extraInfo.vehicleSelect.length; i++) {
        if (this.extraInfo.vehicleSelect[i].id === item.id) {
          index = i
          break
        }
      }
      this.extraInfo.vehicleSelect.splice(index, 1)
      let ids = []
      for (let n in this.extraInfo.vehicleSelect) {
        ids.push(n.id)
      }
      this.updateVehicle(ids)
    },
    changeStatus () {
      this.enableReservation = !this.enableReservation
    },
  }
}
</script>
